import React from 'react';
import {
  Box,
  Flex,
  VStack,
  Text,
} from '@chakra-ui/react';
import Image from "next/image";
import onStreamerTable from "../../assets/on_streamer_table.png";
import { Trans } from '@lingui/macro';

const OnStreamerFaq = () => {
  return (
    <Flex flexDirection="column">
      <Text mb={2}>
        <Trans>
          Untuk setiap dukungan yang diterima oleh streamer, biaya layanan (payment gateway) sebesar 0,8% - 2% akan dipotong dari jumlah tip yang diterima oleh streamer.
        </Trans>
      </Text>
      <Flex flexDirection="row" justifyContent="center">
        <Box
          border="4px"
          borderColor={"gray.200"}
          borderRadius="lg"
          overflow="hidden"
          w="120px"
        >
          <Box bg="orange.400" color="white" p={4} textAlign="center">
            <Text fontSize="xs" fontWeight="bold" height={20} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
              93% s.d 95%
            </Text>
          </Box>
          <Box bg="yellow.400" color="black" p={2} textAlign="center">
            <VStack spacing={1}>
              <Text fontSize="xs">0.8% s.d 2%</Text>
            </VStack>
          </Box>
          <Box bg="gray.100" color="black" p={4} textAlign="center">
            <Text fontSize="xs" fontWeight="bold">5%</Text>
          </Box>
        </Box >
        <Box
          borderRadius="lg"
          overflow="hidden"
          w="80px"
          pl={1}
        >
          <Box color="black" pt={4} textAlign="left">
            <Text fontSize="xs" height={20} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
              <Trans>
                Pendapatan Streamer
              </Trans>
            </Text>
          </Box>
          <Box color="black" pt={7} pb={2} textAlign="left">
            <Text fontSize="xs">
              <Trans>
                Biaya PG
              </Trans>
            </Text>
          </Box>
          <Box color="black" pt={4} textAlign="left">
            <Text fontSize="xs">
              <Trans>
                Platform
              </Trans>
            </Text>
          </Box>
        </Box >
      </Flex>
      <Flex flexDirection="column" mt={3}>
        <Image src={onStreamerTable} />
        <Text fontSize="xs">
          <Trans>
            *Ilustrasi Perhitungan
          </Trans>
        </Text>
      </Flex>
    </Flex>
  );
};

export default OnStreamerFaq;